import { Breadcrumb, Button, Card, Flex, Form, Input, notification } from "antd"
import { useState,useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useInstitucion } from "../../../Hooks/Institucion/useInstitucion"

const {useForm} = Form
const InstitucionGuardar=()=>{
    const navigate=useNavigate()
    const {id} = useParams()
    const [cargando,setCargando] = useState(false)
    const [form] = useForm()
    const {getInstitucion, instituciones,guardar} = useInstitucion()

    const miga=[
        {
            title:<Link to="/">Inicio</Link>
        },
        {
            title:<Link to="/instituciones">Instituciones</Link>
        },
        {
            title:id ? 'Actualizar institución' : 'Registrar nueva institución'
        }
    ]

    const cargar = async () => {
        try {
            setCargando(true);
            const doc = await getInstitucion(id);
            if (doc) {
                form.setFieldsValue({ nombre: doc.nombre });
            }
        } catch (error) {
            notification.error({
                description: error?.response?.data?.mensaje || error?.message || "No se pudo cargar la institución",
            });
            navigate("/instituciones");
        } finally {
            setCargando(false);
        }
    };

    useEffect(()=>{
        if(id){
            cargar()
        }
    },[id])
    
    return <div style={{padding:32}}>
        <Breadcrumb items={miga} />
        <br></br>
        <Flex align="center" justify="center" >
            <Card style={{width:'90%',maxWidth:600}}>
                <Form layout="vertical" onFinish={(values) => guardar(values, id)}>
                    <Form.Item name={'nombre'} label="Nombre" rules={[{required:true,message:'Campo requerido'}]}>
                        <Input/>
                    </Form.Item>
                    
                    <Button loading={cargando} type="primary" htmlType="submit" block>Guardar</Button>
                </Form>
            </Card>
        </Flex>
    </div>
}

export default InstitucionGuardar
